import React from "react";
import { Col, Layout, Row } from "antd";
import ProjectsBoard from "./ProjectsBoard";

const { Content } = Layout;

export default function Projects() {
  return (
    <>
      <Content
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Row
          justify="space-between"
          style={{
            width: "100%",
          }}
        >
          <Col span={24}>
            <Row>
              <Col span={24}>
                <ProjectsBoard />
              </Col>
            </Row>
          </Col>
        </Row>
      </Content>
    </>
  );
}
